import axios from 'axios'
import { Trash2 } from 'lucide-react'
import { useState } from 'react'
import { constants } from '../../Constants'
import { Button, Modal } from '../ui'
import { useToast } from '../ui/Toast/Toast'

export const AlertDialogDeleteUser = ({ user, getAllUsers }) => {
  const [isOpen, setIsOpen] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `${constants.urlLocal}delete/${user._id}`
      )
      if (response.data.ok) {
        toast({ title: 'Usuario eliminado correctamente', status: 'success' })
        getAllUsers()
        setIsOpen(false)
      } else {
        toast({
          title: 'Error al eliminar el usuario',
          description: response.data.message,
          status: 'error',
        })
      }
    } catch (error) {
      console.error(
        'Error al eliminar el usuario: ',
        error.response?.data?.message || error.message
      )
    }
  }

  return (
    <>
      <button
        className="icon-btn icon-btn--danger"
        onClick={() => setIsOpen(true)}
        title="Eliminar"
        aria-label="Eliminar usuario"
        style={{ marginLeft: '0.25rem' }}
      >
        <Trash2 size={16} />
      </button>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={`Eliminar a ${user.name}`}
        size="sm"
      >
        <p>
          ¿Estás seguro? No podrás revertir esta acción después de confirmar
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.5rem',
            marginTop: '1.5rem',
          }}
        >
          <Button variant="ghost" onClick={() => setIsOpen(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Eliminar
          </Button>
        </div>
      </Modal>
    </>
  )
}
